import {
    Box,
    HStack,
    Progress,
    Text,
    VStack,
} from "@chakra-ui/react";
import {
    Wallet,
    TrendingUp,
} from "lucide-react";

import Card from "../../Dashboard/components/Card";

const CommissionLiability = ({
    milestones = [],
}) => {
    const pendingMilestones =
        milestones.filter(
            milestone =>
                milestone.commission_status ===
                "Pending"
        );

    const paidMilestones =
        milestones.filter(
            milestone =>
                milestone.commission_status ===
                "Paid"
        );

    const totalLiability =
        pendingMilestones.reduce(
            (
                total,
                milestone
            ) =>
                total +
                Number(
                    milestone.commission_amount ||
                        0
                ),
            0
        );

    const totalPaid =
        paidMilestones.reduce(
            (
                total,
                milestone
            ) =>
                total +
                Number(
                    milestone.commission_amount ||
                        0
                ),
            0
        );

    const milestoneGroups = [
        {
            title:
                "1st Delivery Bonus",
            type:
                "First Delivery Completed",
        },
        {
            title:
                "10 Deliveries Bonus",
            type:
                "Ten Deliveries Completed",
        },
        {
            title:
                "30 Deliveries Bonus",
            type:
                "Thirty Deliveries Completed",
        },
    ];

    const liabilityBreakdown =
        milestoneGroups.map(
            group => {
                const groupMilestones =
                    pendingMilestones.filter(
                        milestone =>
                            milestone.milestone_type ===
                            group.type
                    );

                const amount =
                    groupMilestones.reduce(
                        (
                            sum,
                            milestone
                        ) =>
                            sum +
                            Number(
                                milestone.commission_amount ||
                                    0
                            ),
                        0
                    );

                const paidAmount =
                    paidMilestones
                        .filter(
                            milestone =>
                                milestone.milestone_type ===
                                group.type
                        )
                        .reduce(
                            (
                                sum,
                                milestone
                            ) =>
                                sum +
                                Number(
                                    milestone.commission_amount ||
                                        0
                                ),
                            0
                        );

                const progress =
                    amount +
                        paidAmount >
                    0
                        ? Math.round(
                              (
                                  paidAmount /
                                  (
                                      amount +
                                      paidAmount
                                  )
                              ) *
                                  100
                          )
                        : 0;

                return {
                    title:
                        group.title,
                    amount,
                    progress,
                };
            }
        );

    return (
        <Card h="100%">
            <HStack
                justify="space-between"
                mb={8}
            >
                <Box>
                    <Text
                        fontSize="2xl"
                        fontWeight="700"
                        color="#071D54"
                    >
                        Commission Liability
                    </Text>

                    <Text
                        color="gray.500"
                        mt={1}
                    >
                        Pending commissions awaiting payout
                    </Text>
                </Box>

                <Box
                    bg="#EEF4FF"
                    p={3}
                    borderRadius="14px"
                    color="#2453FF"
                >
                    <Wallet
                        size={24}
                    />
                </Box>
            </HStack>

            <Box
                bg="#2453FF"
                color="white"
                borderRadius="18px"
                p={6}
                mb={8}
            >
                <Text
                    opacity={0.8}
                    fontSize="sm"
                >
                    Total Liability
                </Text>

                <Text
                    mt={2}
                    fontSize="42px"
                    fontWeight="700"
                >
                    P
                    {totalLiability.toFixed(
                        2
                    )}
                </Text>

                <HStack mt={4}>
                    <TrendingUp
                        size={18}
                    />

                    <Text
                        fontSize="sm"
                    >
                        P
                        {totalPaid.toFixed(
                            2
                        )}{" "}
                        already paid
                    </Text>
                </HStack>
            </Box>

            <VStack
                align="stretch"
                gap={6}
            >
                {liabilityBreakdown.map(
                    item => (
                        <Box
                            key={
                                item.title
                            }
                        >
                            <HStack
                                justify="space-between"
                                mb={2}
                            >
                                <Text
                                    fontWeight="600"
                                    color="#071D54"
                                >
                                    {
                                        item.title
                                    }
                                </Text>

                                <Text
                                    color="#2453FF"
                                    fontWeight="700"
                                >
                                    P
                                    {item.amount.toFixed(
                                        2
                                    )}
                                </Text>
                            </HStack>

                            <Progress.Root
                                value={
                                    item.progress
                                }
                                size="sm"
                                borderRadius="full"
                            >
                                <Progress.Track bg="#E8EEFF">
                                    <Progress.Range bg="#2453FF" />
                                </Progress.Track>
                            </Progress.Root>

                            <Text
                                mt={1}
                                fontSize="xs"
                                color="gray.500"
                            >
                                {
                                    item.progress
                                }
                                % already paid
                            </Text>
                        </Box>
                    )
                )}
            </VStack>
        </Card>
    );
};

export default CommissionLiability;